export const GET_CHAT = "GET_CHAT";
export const DISPLAY_INPUT_OPTION = "DISPLAY_INPUT_OPTION";
export const UPDATE_USER_COUPON = "UPDATE_USER_COUPON";
export const SUBMIT_CHAT = "SUBMIT_CHAT"
export const FORCE_OPEN = "FORCE_OPEN"